import React, { Component } from "react";
import { Link } from "react-router-dom";
import getLabel from './../../../../utils/labels';
import styles from "./introTutorial.module.scss";
import analytics from './../../../../utils/segmentUtils'

class IntroTutorial extends Component {
    componentDidMount() {
        analytics.page('Tutorial start page')
    }

    render() {
        const nextUrl = "/tutorial";
        let { introductionData } = this.props

        return (
            <div className={styles["intro-page-wrapper"]}>
                <div className={styles["intro-text"]} dangerouslySetInnerHTML={{ __html: introductionData.preTutorialPage.tutorialIntroText }} />
                {nextUrl ? (
                    <Link to={nextUrl}>
                        <div className={styles["start-sim-button"]}>
                            <div className={styles["button-text"]}>
                                {getLabel('label_start_tutorial_button')}
                            </div>
                        </div>
                    </Link>
                ) : null}
            </div>
        );
    }
}

export default IntroTutorial;



// WEBPACK FOOTER //
// /src/components/intro/pages/tutorial/IntroTutorial.js